import { config } from './config';
// import { useNavigate } from 'react-router-dom';

// const navigate = useNavigate();

const axios = config.axios;

export async function apiCallAsync(method, path, dataObject) {
    var ax_config = {
        method:method,
        url:path,
        withCredentials:true,
        baseURL:config.apiURLBase
    };
    if (dataObject !== undefined) {
        ax_config.data = dataObject;
        ax_config.headers = {"Content-Type":"application/json"};
    }
    try {
        const response = await axios(ax_config)
        if (response.status == 200) {
            return response.data
        } else {
            // console.log("throwing " + JSON.stringify(response));
            throw(response);
        }
    }
    catch (error) {
        let err = JSON.parse(JSON.stringify(error));
        if (err.status == 401 || err.status == 403) {
            try {
                await refreshToken();
                const retryResponse = await axios(ax_config)
                if (retryResponse.status == 200) {
                    return retryResponse.data
                }
            } catch (retryError) {
                throw(retryError);
            }
        } else {
            // console.log(`error ${error.status}`);
            throw(error);
        }

    }
}

async function refreshToken() {
    try {
        // console.log("refreshToken()");
        const refreshResponse = await axios({
            method:'get',
            url:'https://api.dance-dj.com/?refresh=true',
            withCredentials:true,
        });
    } catch (error) {
        // console.error("Error on Refresh: " + error.toJSON());
        throw(error);
    }
}

export function apiCall(method, path, dataObject) {
    var ax_config = {
        method:method,
        url:path,
        withCredentials:true,
        baseURL:config.apiURLBase
    };
    if (dataObject !== undefined) {
        ax_config.data = dataObject;
        ax_config.headers = {"Content-Type":"application/json"};
    }
    return axios(ax_config).then(function (response) {
        if (response.status == 200) {
            return response.data;
        } else {
            //console.log("response not 200, throwing " + JSON.stringify(response))
            throw(response);
        }
    }).catch(async function (error) {
        let err = JSON.parse(JSON.stringify(error));
        if (err.status == 401 || err.status == 403) {
            try {
                await refreshToken();
            } catch (refError) {
                // console.error("apiCall() refresh error");
                throw(refError);
            }
        } else {
            throw(error);
        }
        // console.log("Retrying API call");
        return axios(ax_config).then(function (response) {
            if (response.status == 200) {
                // console.log("Refresh succeeded");
                return response.data;
            }
        }).catch(function (e) {
            // console.log("Refresh failed");
            throw(e);
        });
    });
}

export default apiCall;